import "core-js/modules/es.array.push.js";
import Swiper from "swiper";
import { WOW } from 'wowjs';
import router from "../router";
export default {
  name: "HomePage",
  data() {
    return {
      map: null
    };
  },
  methods: {
    toContactMe() {
      router.push("contact");
    },
    message() {
      this.$message({
        message: "提交反馈成功",
        type: 'success'
      });
    },
    initMap() {
      var map = new L.map('map');
      var osmUrl = "http://rt0.map.gtimg.com/realtimerender?z={z}&x={x}&y={-y}&type=vector&style=0";
      var osm = new L.tileLayer(osmUrl, {
        minZoom: 17,
        maxZoom: 18
      });
      map.addLayer(osm);
      map.setView(new L.LatLng(22.643640, 114.030347), 17);
      var myIcon = L.divIcon({
        html: '<svg t="1701074075183" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4095" width="48" height="48"><path d="M895.616384 347.812188q0 10.22977-0.511489 19.436563t-1.534466 19.436563q-9.206793 84.907093-37.338661 163.164835t-71.096903 150.377622-99.228771 138.613387-121.734266 127.872128q-9.206793 11.252747-23.528472 11.252747-15.344655 0-24.551449-11.252747-65.470529-61.378621-122.245754-128.895105t-100.251748-141.170829-71.608392-152.935065-36.315684-165.210789q0-8.183816-0.511489-15.344655t-0.511489-15.344655q0-71.608392 28.131868-135.032967t76.211788-110.481518 113.038961-74.677323 138.613387-27.62038 138.101898 27.62038 112.527473 74.677323 76.211788 110.481518 28.131868 135.032967zM540.643357 507.396603q33.758242 0 63.424575-12.787213t51.66034-34.26973 34.781219-50.637363 12.787213-61.89011-12.787213-61.89011-34.781219-50.637363-51.66034-34.26973-63.424575-12.787213-63.424575 12.787213-52.171828 34.26973-35.292707 50.637363-12.787213 61.89011 12.787213 61.89011 35.292707 50.637363 52.171828 34.26973 63.424575 12.787213z" p-id="4096" fill="#d81e06"></path></svg>',
        className: 'my-div-icon',
        iconSize: 60
      });
      this.map = map; // data上需要挂载// 加载底图
      L.marker([22.643750, 114.030547], {
        icon: myIcon
      }).addTo(map);
    }
  },
  mounted() {
    // this.initMap();
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true,
      // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true,
      //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  }
};